/*
 * @Author: Gaho
 * @Date: 2023-12-29 14:36:37
 * @LastEditors: Gaho
 * @LastEditTime: 2023-12-29 14:41:30
 */
const s = {
    ballDistance: 22.2,
    diameter: 11.47,
    numRows: 12,
    ballProp: {
        mass: 1.1,
        densety: .9,
        friction: {
            x: .97,
            y: .93
        }
    },
    xps: {
        0: [325.72738246361365, 323.44701002046594, 325.56461658801, 325.471598699309, 356.45401732622344, 325.3564179976696, 325.72483524347354, 325.9994579138702],
        1: [355.99407708760754, 359.1278490164606, 322.28017050325866, 356.0933910841396, 357.17495067112895, 325.70661463239816, 323.9311319995668, 325.5810797642651],
        2: [357.68624121862416, 356.4559637631956, 325.3596306897858, 356.66066448457576, 325.7254277683613, 325.14633128005784, 359.3573169182669, 356.81430001510813],
        3: [357.7620971901245, 325.2564214679868, 325.78568068380235, 359.39525112801215, 356.9361872850367, 359.12696614080653, 356.37032236058246, 322.4342661917739],
        4: [359.52499977600945, 356.5187511060976, 359.307486453581, 355.8757272764449, 359.3750082058961, 355.96466792541975, 358.9366599409514, 325.80351935091846],
        5: [356.39800111270193, 359.05998075017914, 359.1896659117207, 359.2380108423054, 325.54974088279175, 325.1435029857477, 325.69130329718797, 322.5700167424507],
        6: [324.88170839047575, 322.969489909052, 356.72773231000025, 325.6618992462972, 325.61157782306833, 326.0141154288382, 358.1819034096653, 358.21675178885414],
        7: [356.6846968293174, 325.26341453207556, 359.522517099893, 323.7450076947357, 359.43441406535516, 359.72172606921714, 322.63796622454487, 325.1124202662783],
        8: [356.3910886086, 325.6906210101096, 325.41856731988287, 359.42424840821405, 325.6027277508636, 322.86503994132715, 326.01190200610006, 322.6210242149051],
        9: [325.9194663842539, 357.47673823711494, 322.9733825931149, 322.33990227817804, 359.24133335764213, 357.0023214657117, 322.61843406505284, 325.7786930873078],
        10: [358.56408057384675, 356.27458353682556, 322.9659259882477, 324.5768425123398, 325.0864603737153, 323.1053925763982, 322.9728630316426, 356.4622554308294],
        11: [325.63419635006295, 359.4488579397184, 358.7900386587641, 358.5627380065777, 322.5421582830332, 356.4779854921147, 356.2037240077007, 357.00828199097566],
        12: [356.4479495380605, 356.1299717002171, 359.60700220450207, 323.7985741436501, 356.2088454777418, 356.321319057538, 358.5537396196502, 358.0904794399401],
        13: []
    }
};
export {s as default};
